export var valuesSsoProviderType = ["PPN"];
/*

*/ 
//# sourceMappingURL=SsoProviderType.js.map